import React from 'react';
import RichContent from '../content/RichContent';
import structTagRecoveryHtmlUrl from './content/goresym-struct-tag-recovery.txt';

export default function GoReSymStructTagRecoveryBlog() {
    return <RichContent htmlFileUrl={structTagRecoveryHtmlUrl} />;
}
